



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import DlgAdNew from '../../../modules/ads/_components/DlgAdNew.vue';
import DlgAdDelete from '../../../modules/ads/_components/DlgAdDelete.vue';
import DlgAdEdit from '../../../modules/ads/_components/DlgAdEdit.vue';
import Card from '../../../components/material/Card.vue';
import ImageUploader from '@/modules/files/_components/imageUploader.vue';

@Component({
  components: {
    ImageUploader,
    DlgAdNew,
    DlgAdDelete,
    DlgAdEdit,
    Card,
  },
})
export default class NewCampaignArticle extends Vue {
  public $refs!: {
    image: any,
  };

  @Action('campaignArticles/upload') private upload!: any;
  @Action('campaignArticles/create') private create!: any;
  @Action('campaignArticles/setNewArticle') private setNewArticle!: any;

  @Getter('campaignArticles/newArticle') private storeNewArticle!: any;

  @Prop(String) private readonly id!: string;

  private loading: boolean = false;
  private isEditing: boolean = true;

  get newArticle() {
    return this.storeNewArticle;
  }

  set newArticle(article) {
    this.setNewArticle(article);
  }

  private created() {
    this.loading = true;
    this.newArticle.campaignId = this.id;
    this.loading = false;
  }

  private async createArticle() {
    this.loading = true;
    const url = await this.$refs.image.doUpload();
    const res = await this.create({...this.newArticle, image: url});
    if (res) {
      this.newArticle = {};
      this.isEditing = false;
      this.$router.back();
    }
    this.loading = false;
  }
}
